export default "__VITE_ASSET__mvRFphWv__"